import React from "react";
import "./home.css";
import GallerySection from "../gallery/gallery";


function Bio() {
  const scrollToSection = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      {/* HEADER */}
      <nav className="navbar navbar-expand-lg bg-green text-white sticky-top">
        <div className="container">
          <a className="navbar-brand text-white fw-bold" href="#">
            K VETRIVEL
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="text-white fs-3">☰</span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav text-white ms-auto">
              <li className="nav-item">
                <button
                  className="nav-link btn text-white"
                  onClick={() => scrollToSection("home")}
                >
                  Home
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link btn text-white"
                  onClick={() => scrollToSection("about")}
                >
                  Social Service
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link btn text-white"
                  onClick={() => scrollToSection("contribution")}
                >
                  Achievements
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link btn text-white"
                  onClick={() => scrollToSection("gallery")}
                >
                  Gallery
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link btn text-white"
                  onClick={() => scrollToSection("contact")}
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* HOME / INTRO SECTION */}
      <section id="home" className="container my-5">
        <div className="row align-items-center">
          {/* LEFT - IMAGE */}
          <div className="col-md-5 text-center mb-4 mb-md-0">
            <img
              src="images/main-img1.jpeg"
              alt="candidate"
              className="img-fluid rounded shadow"
            />
          </div>

          {/* RIGHT - DETAILS */}
          <div className="col-md-7">
            <h2 className="fw-bold">K VETRIVEL</h2>
            <p className="text-muted">
              <b>
                <h4 className="fw-bold">
                  “From the people, for the people - driven by years of
                  dedicated service.”
                </h4>
              </b>
            </p>

            <p>
              <strong>Education: </strong> Diploma in EEE.
            </p>
            <p>
              <strong>Occupation: </strong> Advertise Associate & Motivational
              Speaker.
            </p>
            <p>
              <strong>Native: </strong> Akkinathapuram villege , Thiruvaiyaru,
              Thanjavur district, Tamil Nadu.
            </p>
            <p>
              <strong>Live In: </strong> Kodambakkam, Chennai, Tamil Nadu - 600024.
            </p>

            <button
              className="btn btn-success mt-3"
              onClick={() => scrollToSection("about")}
            >
              Learn More
            </button>
          </div>
        </div>
      </section>

      <section id="plans" className="py-5 bg-light">
        <div className="container">
          {/* Title */}
          <div className="text-center mb-5">
            <h2 className="fw-bold text-success">
              Independent Candidate Vetrivel – 20 Key Promises
            </h2>
            <p className="text-muted">
              A vision for a safer, greener, and progressive constituency
            </p>
          </div>

          <div className="accordion" id="plansAccordion">
            {/* 1 */}
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button fw-bold text-success"
                  data-bs-toggle="collapse"
                  data-bs-target="#plan1"
                >
                  1. Drug-Free Constituency
                </button>
              </h2>
              <div
                id="plan1"
                className="accordion-collapse collapse show"
                data-bs-parent="#plansAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    <li>Anti-drug awareness campaigns</li>
                    <li>Rehabilitation centers & counseling</li>
                    <li>Employment & monitoring for recovered individuals</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 2 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-toggle="collapse"
                data-bs-target="#plan2"
              >
                2. “One Vote – One Tree” Initiative
              </button>
              <div
                id="plan2"
                className="accordion-collapse collapse"
                data-bs-parent="#plansAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    <li>Plant one sapling for each vote</li>
                    <li>Create tree maintenance groups</li>
                    <li>3-year monitoring & protection</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 3 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-toggle="collapse"
                data-bs-target="#plan3"
              >
                3. Rainwater Harvesting Revolution
              </button>
              <div
                id="plan3"
                className="accordion-collapse collapse"
                data-bs-parent="#plansAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    <li>Setup recharge pits</li>
                    <li>Convert drains into rainwater storage</li>
                    <li>Groundwater monitoring system</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 4 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-toggle="collapse"
                data-bs-target="#plan4"
              >
                4. Cleanliness & Digital Toilet Monitoring
              </button>
              <div
                id="plan4"
                className="accordion-collapse collapse"
                data-bs-parent="#plansAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    <li>Upgrade all public toilets</li>
                    <li>Digital feedback system</li>
                    <li>Issue resolution within 48 hours</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 5 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-toggle="collapse"
                data-bs-target="#plan5"
              >
                5. Traffic Management Reform
              </button>
              <div id="plan5" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Traffic study on major roads</li>
                    <li>Pedestrian & parking regulation</li>
                    <li>Community-based traffic control</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 6 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-toggle="collapse"
                data-bs-target="#plan6"
              >
                6. Accident-Free Constituency
              </button>
              <div id="plan6" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Fix speed breakers</li>
                    <li>Install warning signs</li>
                    <li>Road safety awareness programs</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 7 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan7"
                data-bs-toggle="collapse"
              >
                7. Free Higher Education Coaching Centers
              </button>
              <div id="plan7" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Free coaching centers</li>
                    <li>Expert faculty & study materials</li>
                    <li>Mock tests & career guidance</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 8 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan8"
                data-bs-toggle="collapse"
              >
                8. Weekly Medical Camps
              </button>
              <div id="plan8" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Weekly health camps</li>
                    <li>Free check-ups & medicines</li>
                    <li>Disease prevention awareness</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 9 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan9"
                data-bs-toggle="collapse"
              >
                9. Youth Sports Development
              </button>
              <div id="plan9" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Sports training centers</li>
                    <li>Talent identification camps</li>
                    <li>Support for state & national competitions</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 10 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan10"
                data-bs-toggle="collapse"
              >
                10. 24x7 Security Monitoring
              </button>
              <div id="plan10" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>CCTV installation in key areas</li>
                    <li>Police-integrated control room</li>
                    <li>Youth safety teams</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 11 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan11"
                data-bs-toggle="collapse"
              >
                11. Police & Army Training Centers
              </button>
              <div id="plan11" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Training camps</li>
                    <li>Physical & written coaching</li>
                    <li>Recruitment guidance</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 12 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan12"
                data-bs-toggle="collapse"
              >
                12. Third Gender Welfare
              </button>
              <div id="plan12" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Educational scholarships</li>
                    <li>Employment opportunities</li>
                    <li>Social integration & safety</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 13 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan13"
                data-bs-toggle="collapse"
              >
                13. TASMAC Regulation
              </button>
              <div id="plan13" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Inspection of problematic outlets</li>
                    <li>Closure of unnecessary shops</li>
                    <li>Women safety measures</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 14 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan14"
                data-bs-toggle="collapse"
              >
                14. Women Self-Employment Revolution
              </button>
              <div id="plan14" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Formation of self-help groups</li>
                    <li>Skill development training</li>
                    <li>Loan & marketing support</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 15 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan15"
                data-bs-toggle="collapse"
              >
                15. Support for the Needy
              </button>
              <div id="plan15" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Support for elderly & women</li>
                    <li>Livelihood assistance programs</li>
                    <li>Government scheme linkage</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 16 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan16"
                data-bs-toggle="collapse"
              >
                16. Safe Hostels
              </button>
              <div id="plan16" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Affordable hostels for students/workers</li>
                    <li>Security monitoring</li>
                    <li>Low-cost facilities</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 17 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan17"
                data-bs-toggle="collapse"
              >
                17. Park Renovation
              </button>
              <div id="plan17" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Park redevelopment</li>
                    <li>Increase greenery</li>
                    <li>Install play equipment</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 18 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan18"
                data-bs-toggle="collapse"
              >
                18. Youth Social Service Movement
              </button>
              <div id="plan18" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Youth volunteer groups</li>
                    <li>Community service projects</li>
                    <li>Leadership training</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 19 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan19"
                data-bs-toggle="collapse"
              >
                19. Public Grievance Redressal (48 Hours)
              </button>
              <div id="plan19" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Online & offline complaint system</li>
                    <li>Direct monitoring</li>
                    <li>Resolution within 48 hours</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 20 */}
            <div className="accordion-item">
              <button
                className="accordion-button collapsed fw-bold text-success"
                data-bs-target="#plan20"
                data-bs-toggle="collapse"
              >
                20. “Best Constituency in Tamil Nadu”
              </button>
              <div id="plan20" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <ul>
                    <li>Environmental protection programs</li>
                    <li>Improved safety & healthcare</li>
                    <li>Holistic development initiatives</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section id="about" className="py-5">
        <div className="container">
          {/* Title */}
          <div className="text-center mb-5">
            <h2 className="fw-bold">Social Service</h2>
            <p className="text-muted">
              Commitment towards environment, society, and future generations
            </p>
          </div>

          {/* Intro Card */}
          <div className="card shadow p-4 mb-4 border-0">
            <p>
              Founder of <strong>Awareness India Movement (AIM)</strong>, a
              social service organization focused on creating a greener
              environment and driving social development across communities.
            </p>
          </div>

          {/* Activities */}
          <div className="row g-4">
            <div className="col-md-6">
              <div className="card h-100 shadow-sm p-3 border-0">
                <h5 className="fw-bold">🌱 Tree Plantation</h5>
                <p>
                  From 2017 to 2023, over <strong>25,000 saplings</strong> were
                  planted across Chennai to promote environmental
                  sustainability.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card h-100 shadow-sm p-3 border-0">
                <h5 className="fw-bold">🍛 Food Distribution</h5>
                <p>
                  Supported people in need during the COVID period by
                  distributing food to affected communities.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card h-100 shadow-sm p-3 border-0">
                <h5 className="fw-bold">📢 Awareness Programs</h5>
                <p>
                  Conducted awareness campaigns for students and the public on
                  topics like clean streets, drug-free society, and responsible
                  voting.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card h-100 shadow-sm p-3 border-0">
                <h5 className="fw-bold">🎓 Educational & Medical Support</h5>
                <p>
                  Provided assistance to underprivileged students and organized
                  daily training in robotics and skill development.
                </p>
              </div>
            </div>

            <div className="col-md-12">
              <div className="card shadow-sm p-3 border-0">
                <h5 className="fw-bold">🧹 Cleaning Movement</h5>
                <p>
                  Weekly cleaning initiatives conducted in Kodambakkam with
                  active participation from volunteers.
                </p>
              </div>
            </div>
          </div>

          {/* Mission */}
          <div className="mt-5 text-center">
            <div className="p-4 bg-green highlight-green rounded rounded shadow">
              <h5 className="fw-bold text-white">
                🌍 Mission: 1 Crore Trees by 2026
              </h5>
              <p className="mb-0">
                Awareness India Movement is on a journey towards planting 1
                crore trees and achieving a Guinness World Record, building a
                greener future for generations to come.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="contribution" className="py-5">
        <div className="container">
          {/* Title */}
          <div className="text-center mb-5">
            <h2 className="fw-bold">Contributions & Achievements</h2>
            <p className="text-muted">
              Impactful work towards society and recognized excellence
            </p>
          </div>

          <div className="row g-4">
            {/* Contributions */}
            <div className="col-md-6">
              <div className="card shadow h-100 border-0 p-4">
                <h4 className="fw-bold mb-3">🌱 Contribution to Society</h4>
                <ul className="list-unstyled">
                  <li className="mb-3">
                    ✅ Planted <strong>2,50,000 saplings</strong> across Tamil
                    Nadu in 2024, promoting environmental sustainability.
                  </li>
                  <li className="mb-3">
                    ✅ Every year on Memorial Day of{" "}
                    <strong>Dr. A.P.J. Abdul Kalam</strong>, coordinated nearly{" "}
                    <strong>3000 students</strong> to drive social change.
                  </li>
                </ul>
              </div>
            </div>

            {/* Achievements */}
            <div className="col-md-6">
              <div className="card shadow h-100 border-0 p-4">
                <h4 className="fw-bold mb-3">🏆 Achievements</h4>
                <ul className="list-unstyled">
                  <li>🏅 Green Champion Award – Tamil Nadu Govt (2025)</li>
                  <li>🏅 Atal Award – Atal Smriti (2025)</li>
                  <li>🏅 Lionize Book of World Records (2023)</li>
                  <li>🏅 Lincoln Book of Records (2021)</li>
                  <li>🏅 SPT National Peace Award (2017)</li>
                  <li>🏅 Rainwater Harvesting Award – MCC (2019)</li>
                  <li>🏅 Singara Chennai 2.0 Award (2021)</li>
                  <li>🏅 Honoured by K.J Praveen Kumar I.A.S</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Highlight Banner */}
          <div className="mt-5">
            <div className="bg-green highlight-green rounded text-center p-4 rounded shadow">
              <h5 className="fw-bold text-white mb-2">
                “Dedicated to building a greener, stronger, and socially
                responsible future.”
              </h5>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery section */}
      <GallerySection />

      {/* CONTACT */}
      <section id="contact" className="pt-5 highlight-green text-white">
        <div className="container">
          <div className="row align-items-center text-center text-md-start">
            {/* LEFT - IMAGE + NAME */}
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="text-center">
                <img
                  src="images/footer-img.jpeg"
                  alt="Vetrivel"
                  className="img-fluid rounded-circle shadow mb-3 "
                  style={{
                    width: "250px",
                    height: "250px",
                    objectFit: "cover"
                  }}
                />
                {/* <h4 className="fw-bold text-white">K VETRIVEL</h4> */}
                {/* <p className="small">Independent Candidate</p> */}
              </div>
            </div>

            {/* MIDDLE - CONTACT DETAILS */}
            <div className="col-md-4 mb-4 text-white mb-md-0">
              <h5 className="fw-bold mb-3 text-white ">Contact Info</h5>
              <p>
                📍 Saravanapriya Apartments, Gopala Menon Street,<br></br> Kodambakkam, <br></br>Chennai, Tamil Nadu - 600024
              </p>
              <p>
                📞{" "}
                <a
                  href="tel:+919884049288"
                  className="text-white text-decoration-none"
                >
                  +91 98840 49288
                </a>
              </p>

              <p>
                ✉️{" "}
                <a
                  href="mailto:vettri008@gmail.com"
                  className="text-white text-decoration-none"
                >
                  vettri008@gmail.com
                </a>
              </p>

              <div className="mt-3">
                <p className="mb-1">🌐 Social Media</p>
                <p className="small">
                  <a
                    href="https://www.instagram.com/kodambakkam_vetri"
                    target="_blank"
                  >
                     Instagram{" "}
                  </a>{" "}
                  |
                  <a
                    href="https://www.facebook.com/share/18X5zsFrew/"
                    target="_blank"
                  >
                    {" "}
                     Facebook{" "}
                  </a>{" "}
                  |
                  <a
                    href="https://www.youtube.com/@aimkalamtv2748"
                    target="_blank"
                  >
                    {" "}
                   Youtube{" "}
                  </a>
                </p>
              </div>
            </div>

            {/* RIGHT - QUICK LINKS */}
            <div className="col-md-4">
              <h5 className="fw-bold mb-3 text-white ">Quick Links</h5>
              <ul className="list-unstyled">
                <li>
                  <button
                    className="btn btn-link text-white text-decoration-none p-0"
                    onClick={() => scrollToSection("home")}
                  >
                    Home
                  </button>
                </li>
                <li>
                  <button
                    className="btn btn-link text-white text-decoration-none p-0"
                    onClick={() => scrollToSection("about")}
                  >
                    Social Service
                  </button>
                </li>
                <li>
                  <button
                    className="btn btn-link text-white text-decoration-none p-0"
                    onClick={() => scrollToSection("contribution")}
                  >
                    Achievements
                  </button>
                </li>
                <li>
                  <button
                    className="btn btn-link text-white text-decoration-none p-0"
                    onClick={() => scrollToSection("gallery")}
                  >
                    Gallery
                  </button>
                </li>
                <li>
                  <button
                    className="btn btn-link text-white text-decoration-none p-0"
                    onClick={() => scrollToSection("contact")}
                  >
                    Contact
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Bottom Line */}
        <div className="text-center mt-1 pt-3 border-top border-light">
          <small>© 2026 K Vetrivel. All Rights Reserved.</small>
        </div>
      </section>
    </div>
  );
}

export default Bio;
